import(/* webpackMode: "eager" */ "/app/src/app/(legal)/terms/page.tsx");
